"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRILNICA_COMPANY_ID = '606b9433-b402-4ce4-8777-5516f59256c5';
//# sourceMappingURL=index.js.map